import { gql } from "@apollo/client";

/**
 * Newest IoT commissioning event of an asset (IBM-1045). While it is younger
 * than COMMISSIONING_PENDING_WINDOW_HOURS and the SLA is still INACTIVE (or
 * EVALUATION_FAILED), the
 * asset hero shows the "submitted" line instead of the "Start commissioning"
 * button (IoT flips the status to EVALUATION asynchronously). Only sent
 * while REACT_APP_ENABLE_SLA is on (callers `skip` otherwise).
 */
export const LatestIotCommissioningEvent = gql`
  query LatestIotCommissioningEvent($assetId: ID!) {
    installedBaseEventList(filter: { assetId: { equals: $assetId }, eventType: { equals: ASSET_IOT_COMMISSIONING } }) {
      total
      installedBaseEvents(pagination: { start: 0, limit: 1 }, sort: { insert: desc }) {
        id
        insert
        user {
          id
          name
        }
      }
    }
  }
`;
